import React from 'react';
import styles from './TransportActionBtns.module.scss';
import { ReactComponent as EditNewIcon } from '../../../../../../resource/EditNewIcon.svg';
import { useQueryClient } from 'react-query';
import { getQueryKeys } from '../../../../shared/lib/getQueryKeys';
import DeleteTransportBtn from '../../../../../../components/DeleteTransportBtn/DeleteTransportBtn';
import { modalType, useModal } from '../../../../shared/modalProvider';
import useTransportCheckPermit from '../../../../../../queries/useTransportCheckPermit';
import { Icon, message } from 'antd';

const TransportActionBtns = ({ record }) => {
  const queryClient = useQueryClient();

  const companyId = record?.company?.id;
  const id = record?.transport?.id;
  const clientId = record?.clients?.[0]?.id;
  const addressId = record?.clients?.[0]?.addressId;

  const { mutateAsync: checkTransport, isLoading } = useTransportCheckPermit();

  const { open: openTransport } = useModal(modalType.TRANSPORT_FORM);

  const keyTransports = getQueryKeys.transports(companyId);

  const onSuccess = () => {
    queryClient.refetchQueries(keyTransports);
  };

  const handleClick = async (e) => {
    e.stopPropagation();

    const res = await checkTransport({ transportId: id });

    if (!res?.success) {
      message.info(
        'У данного ТС есть пропуска, редактирование ТС запрещено',
        3
      );
      return;
    }

    openTransport({ id, onSuccess, clientId, addressId, companyId });
  };

  return (
    <div className={styles.root}>
      {isLoading ? (
        <Icon style={{ color: '#0995ED' }} />
      ) : (
        <EditNewIcon
          onClick={handleClick}
          className={styles.btnEdit}
        />
      )}
      <DeleteTransportBtn
        transportId={id}
        clientId={clientId}
        addressId={addressId}
        companyId={companyId}
        transport={record?.transport}
        onSuccess={onSuccess}
      />
    </div>
  );
};

export default TransportActionBtns;
